import React from 'react';
import { setClosingThunk } from "../../redux/thunks/interactionsThunk";
import { useDispatch } from "react-redux";

const CloseBtn = () => {
  const dispatch = useDispatch();

  const handleViewerClose = async () => {
    await dispatch(setClosingThunk());
  };

  return (
    <div className="CloseBtn">
      <button id="InternalBtn" onClick={() => handleViewerClose()}></button>
    </div>
  )
}

export default CloseBtn;
